<template>
    <div>
        <modal
      name="FilingFeesPopup"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="800px"
      height="auto"
    >
      <div class="v-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Filing Fees</h2>
          <span @click="$modal.hide('FilingFeesPopup');hideMe()">
            <em class="material-icons">close</em> 
          </span>
        </div>
        <form  data-vv-scope="filingFeesform" @submit.prevent>
          <div class="form-container filingFeesformcontainer mt-0"  @click="filingFeeformerrors = ''" >
            <div class="filing_fields w-100">
              <fileUploadNote :fileNote="true" />
              <div class="vx-row ml-0 mr-0 pl-3 pr-3" v-if="false">
                <datepickerField  :display="true"  :dateEnableTo="new Date()"  :wrapclass="'md:w-1/2'"  :validationRequired="true" v-model="invoiceDate"
                :fieldName="'invoiceDate'" label="Invoice Date" :formscope="'filingFeesform'" />
                <datepickerField  :display="true" :dateEnableFrom="new Date()"   :wrapclass="'md:w-1/2'"  :validationRequired="true" v-model="dueDate" 
                :fieldName="'dueDate'" label="Due Date" :formscope="'filingFeesform'" />
                <!-- @input="checkDueDate" -->
              </div>
              <template >
                
                <div class="form-container pl-5 pr-5 pt-0">
                <div class="vx-row" >
                  <div class="accordian-table filingdata_table filingdata_table_v2" >
                    
                     <vs-table :data="filingFeeData">
                     
                      <template v-if="filingFeeData.length > 0" slot="thead">
                        <vs-th>Fee Type</vs-th>
                        <vs-th>Amount($)</vs-th>
                        <!-- <vs-th>Exclude from Invoice</vs-th> -->
                      </template>
                      <template slot-scope="{ data }">
                        
                        <h3 v-if="getUscisSection" class="small-header pb-0 pt-2">USCIS Fees</h3> 
                        <vs-tr :data="filingFee" :key="index" v-for="(filingFee ,index) in filingFeeData" class="vs-table--tr" :class="{'new-invoice-item':checkProperty(filingFee ,'newly_add')}" v-if="filingFee.descriptionType=='USCIS'  && checkProperty(filingfee, 'isSelected')">
                          <vs-td><span>{{ filingFee.description  }}</span></vs-td>
                          <vs-td>
                           
                            <div class="amount_edit mb-0" >
                                  <vs-input
                                  data-vv-as="Amount"
                                  v-validate="'required'"
                                  v-model="filingFee.amount"
                                  :name="'amountUSCIS'+index"
                                  v-mask="'#####'"
                                  class="amount_input input_prefix"
                                />
                                <span
                                  class="text-danger text-sm"
                                  v-show="errors.has('filingFeesform.amountUSCIS'+index)"
                                  >{{ errors.first("filingFeesform.amountUSCIS"+index) }}
                                </span>
                            </div>
                          </vs-td>
                          <!-- <vs-td>
                            <vs-checkbox v-model="filingFee.invoice" :name="'amountUSCISinvoice'+index"
                            ></vs-checkbox>
                          </vs-td> -->
                        </vs-tr>   
                        <h3 v-if="getInternalSection" class="small-header pb-0 pt-2">Attorney Fees</h3>                    
                        <vs-tr :data="filingFee" :key="index" v-for="(filingFee ,index) in filingFeeData" class="vs-table--tr" :class="{'new-invoice-item':checkProperty(filingFee ,'newly_add')}" v-if="filingFee.descriptionType=='Internal'  && checkProperty(filingfee, 'isSelected')">
                          <vs-td>{{ filingFee.description  }}</vs-td>
                          <vs-td>
                            <div class="amount_edit mb-0" >
                                  <vs-input
                                  data-vv-as="Amount"
                                  v-validate="checkProperty(getUserData, 'tenantDetails', 'slug') == 'slg'?'':'required'"
                                  v-model="filingFee.amount"
                                  :name="'amountAttorney'+index"
                                  v-mask="'#####'"
                                  class="amount_input input_prefix"
                                />
                                <span
                                  class="text-danger text-sm"
                                  v-show="errors.has('filingFeesform.amountAttorney' + index)"
                                  >{{ errors.first("filingFeesform.amountAttorney" + index) }}
                                </span>
                            </div>
                          </vs-td>
                          <!-- <vs-td>
                            <vs-checkbox v-model="filingFee.invoice" :name="'invoiceAttorney' + index"
                                  ></vs-checkbox>
                          </vs-td> -->
                        </vs-tr>
                        <h3 v-if="getotherSection" class="small-header pb-0 pt-2">Other Fees</h3> 
                        <vs-tr :data="filingFee" :key="index" v-for="(filingFee ,index) in filingFeeData" class="vs-table--tr" :class="{'new-invoice-item':checkProperty(filingFee ,'newly_add')}" v-if="filingFee.descriptionType=='Other' && checkProperty(filingfee, 'isSelected')">
                          <vs-td><span>{{ filingFee.description  }}</span></vs-td>
                          <vs-td>
                           
                            <div class="amount_edit mb-0" >
                                  <vs-input
                                  data-vv-as="Amount"
                                  v-validate="'required'"
                                  v-model="filingFee.amount"
                                  :name="'amountUSCIS'+index"
                                  v-mask="'#####'"
                                  class="amount_input input_prefix"
                                />
                                <span
                                  class="text-danger text-sm"
                                  v-show="errors.has('filingFeesform.amountUSCIS'+index)"
                                  >{{ errors.first("filingFeesform.amountUSCIS"+index) }}
                                </span>
                            </div>
                          </vs-td>
                          <!-- <vs-td>
                            <vs-checkbox v-model="filingFee.invoice" :name="'amountUSCISinvoice'+index"
                            ></vs-checkbox>
                          </vs-td> -->
                        </vs-tr> 
                      </template>
                     </vs-table>
                  
              
                    </div>
                <div class="vx-col w-full padlr20 " @click="value = [];uploading=false;DocErr=false">
                <div class="form_group file_group mb-0">
                  <div class="vs-component marb10">
                    <label class="form_label">Cheques<em>*</em></label>
                    <div class="relative">
                      <file-upload v-model="value" class="file-upload-input upload_file justify-center"
                        :accept="allDocEntity" @updateData="updateData"
                        :name="'Documents'" :multiple="true" :hideSelected="true" 
                        >
                        <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                        Upload
                      </file-upload>
                      <span v-if="uploading" class="loader"><img src="@/assets/images/main/loader.gif" /></span>
                      <span class="text-danger text-sm" v-if="DocErr">*Documents are required</span>
                    </div>
                  </div>
                  <ul class="uploaded-list note_uploads">
                    <template v-for="(item, index) in filingFeeDocs">
                      <vs-chip @click="remove(item, filingFeeDocs, index)" :key="index" closable>
                        <img src="@/assets/images/main/down-arrow2.svg" @click="download_or_view(item)" />
                        {{ item.name }}
                      </vs-chip>
                    </template>
                  </ul>
                </div>
              </div>
                </div>
              </div>
              </template>
              <template v-if="false">
                <div class="filing_fees_v2">
                  <template vs-w="12" v-for="(filingFee, index) in filingFeeData" >
                    <div class="amount_sec" :key="index">
                      <vs-row class="pb-0">
                        <vs-col vs-xs="12">
                          <div class="form_group">
                            <label class="form_label">Fee Type<em>*</em></label>
                              <ckeditor  data-vv-as="Description"
                                v-validate="'required'"
                                v-model="filingFee.description"
                                :name="'filingdescription' + index"
                                class="w-full" :editor="editor" :config="editorConfig"></ckeditor>
                              <span
                                class="text-danger text-sm"
                                v-show="
                                  errors.has('filingFeesform.filingdescription' + index)
                                "
                                >{{
                                  errors.first("filingFeesform.filingdescription" + index)
                                }}</span
                              >
                          </div>
                        </vs-col>
                        <vs-col vs-xs="12">
                          <vx-input-group>
                            <div class="form_group">
                              <label class="form_label">Amount($)<em>*</em></label>
                              <div class="comments_sec mb-0">
                                <vs-input
                                data-vv-as="Amount"
                                v-validate="'required'"
                                v-model="filingFee.amount"
                                :name="'amount' + index"
                                v-mask="'#####'"
                                class="amount_input input_prefix"
                              />
                              <span
                                class="text-danger text-sm"
                                v-show="errors.has('filingFeesform.amount' + index)"
                                >{{ errors.first("filingFeesform.amount" + index) }}</span
                              >
                              
                              <div
                                class="delete"
                                v-if="filingFeeData.length > 1"
                                @click="removefilingfee(index)"
                              >
                                <a>
                                  <img src="@/assets/images/main/delete-row-img.svg" />
                                </a>
                              </div>
                              </div>
                              
                            </div>
                           
                          </vx-input-group>
                        </vs-col>
                      </vs-row>
                      <vs-row class="border-0 pl-8 pt-0">
                        <vs-checkbox v-model="filingFee.invoice" :name="'invoice' + index"
                          >Exclude from invoice</vs-checkbox
                        >
                      </vs-row>
                    </div>
                  </template>
                </div>
                <vs-row class="more_btn_wrap pl-8 pb-3 pt-0">
                <vs-col
                  class="float-none pl-0 pb-0 more_btn"
                  vs-type="flex"
                  vs-align="center"
                >
                  <a @click="addfilingfee" class="add-more ml-0" type="filled">
                    <span>+</span> More
                  </a>
                </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                    <div class="filing_comments p-0">
                      <div class="form_group">
                        <label class="form_label">Note<em>*</em></label>
                        <!-- <vs-textarea
                          data-vv-as="Note"
                          v-validate="'required'"
                          v-model="filingFeeComment"
                          :name="'filingFeeComment'"
                          class="w-full"
                        /> -->
                        <ckeditor  data-vv-as="Note"
                          v-validate="'required'"
                          v-model="filingFeeComment"
                          :name="'filingFeeComment'"
                          class="w-full" :editor="editor" :config="editorConfig"></ckeditor>

                        <span
                          v-if="validatefilingFeeDescrition"
                          class="text-danger text-sm"
                          v-show="errors.has('filingFeesform.filingFeeComment')"
                          >{{ errors.first("filingFeesform.filingFeeComment") }}</span
                        >
                      </div>
                    </div>
                    
                  </vs-col>
                </vs-row>
              </template>  
            </div>       
          </div>
          <div class="text-danger text-sm formerrors"  v-if="filingFeeformerrors!=''">
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ filingFeeformerrors }}</vs-alert
            >
          </div>
          <div class="popup-footer relative">
            <span class="loader" v-if="submitingFilingFee"
              ><img src="@/assets/images/main/loader.gif"
            /></span>
            <vs-button
              color="dark"
              @click="hideMe()"
              class="cancel"
              type="filled"
              >Cancel</vs-button
            >
            <vs-button
              color="success"
              v-if="editFilngFee"
              :disabled="submitingFilingFee"
              @click="createOrupdateInvoice"
              class="save"
              type="filled"
            >
              Update</vs-button
            >
            <vs-button
              color="success"
              v-else
              :disabled="submitingFilingFee"
              @click="submitFilingFees"
              class="save"
              type="filled"
              >Submit</vs-button
            >
          </div>
        </form>
      </div>
    </modal>
    </div>
</template>
<script>
    import moment from "moment";
    import Vue from 'vue';
    Vue.use( CKEditor );
    import CKEditor from '@ckeditor/ckeditor5-vue2';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import fileUploadNote from "@/views/common/fileUploadNote.vue";
    import datepickerField from "@/views/forms/fields/datepicker.vue";
    import FileUpload from "@/views/FileUpload.vue";
    export default{
        provide() {
            return {
                parentValidator: this.$validator,
            };
        },
        data: () => ({
          configDetails:null,
          invoicecategoryList:[],
          filingFeeComment: "",
          editFilngFee:false,
          submitingFilingFee:false,
          filingFeeformerrors:'',
          DocErr:false,
          uploading:false,
          editor: ClassicEditor,
          editorConfig: {
              toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
          },
          filingFeeDocs:[],
            value:[],
            dueDate:null,
            invoiceDate:null,
            filingFeeData: [
              {
                amount: null,
                invoice: false,
                description: "",
              },
            ],
        }),
        components: {
          FileUpload,
          fileUploadNote,
          datepickerField
        },
        props: {
            petitionDetails:null,
        },
        methods:{
          checkDueDate(){
            if(this.invoiceDate && this.dueDate){
              let startDate = moment(val);
              let endDate= moment(this.dueDate)
              if(startDate.isAfter(endDate , 'day')){
                this.dueDate = null;
              }
            }
          },
          hideMe(){
            this.$emit('hideInvoiceMe')
            setTimeout(()=>{
              this.$modal.hide("FilingFeesPopup");
            })
          },
          updateData(docs){
            this.filingFeeDocs = docs;
          },
          addfilingfee: function () {
      let isValied = true;
      this.validatefilingFeeDescrition = false;
      this.$validator.validateAll("filingFeesform").then((result) => {
        if (this.filingFeeData.length > 0) {
          _.forEach(this.filingFeeData, (item, index) => {
            if (
              this.errors.has("filingFeesform.amount" + index) ||
              this.errors.has("filingFeesform.filingdescription" + index)
            ) {
              isValied = false;
            }
          });
        }

        if (isValied) {
          this.filingFeeData.push({
            amount: null,
            description: "",
            invoice: false,
          });

          this.$validator.reset("filingFeesform.filingFeeComment");
        }
      });
          },
          removefilingfee: function (index) {
            this.filingFeeData.splice(index, 1);
            //Vue.delete(this.filingFeeData, index);
          },
          submitFilingFees() {
      this.validatefilingFeeDescrition = true;
      this.filingFeeformerrors = "";
      this.DocErr=false;
       if(this.checkProperty(this.petitionDetails,'filingFeeCategoryType')=='pre_defined' && this.checkProperty(this.filingFeeDocs,'length')<=0){
        this.DocErr=true;
       
       }
      
      this.$validator.validateAll("filingFeesform").then((result) => {
        
       
        if (result && this.DocErr==false) {
          this.DocErr=false;
          let includeInvoicesList = _.filter(this.filingFeeData ,{"invoice":false});
          if(includeInvoicesList && includeInvoicesList.length<=0){
            this.filingFeeformerrors = "Include at least one item into invoice";
            return false;
          }
     
          var totala = 0;
          this.filingFeeData.forEach((i) => {
            if(i.amount){
              totala = totala + parseInt(i.amount);
            }
            
          });
          var postData = {
            subTypeName: this.checkProperty(
              this.getPetitionDetails,
              "subTypeDetails",
              "name"
            ),
            typeName: this.checkProperty(this.getPetitionDetails, "typeDetails", "name"),
            petitionId: this.checkProperty(this.getPetitionDetails, "_id"),
            filingFeeData: this.filingFeeData,
            today: moment().format("YYYY-MM-DD"),
            comment:this.filingFeeComment,
            filingFeeDocs:{ "cheques":[]}, //this.filingFeeDocs,
            invoiceDate:this.invoiceDate,
            dueDate:this.dueDate,
            
          };
          if(this.filingFeeDocs.length>0){
            postData['filingFeeDocs']['cheques'] = this.filingFeeDocs;
            // filingFeeDocs:{ "cheques":[]} //this.filingFeeDocs,
          }
         
          
          this.submitingFilingFee = true;
          this.$store
            .dispatch("commonAction", {
              data: postData,
              path: "/petition/save-filing-fees",
            })
            .then((response) => {
             
              this.createOrupdateInvoice("save-filing-fees");
            })
            .catch((error) => {
              this.submitingFilingFee = false;
              this.filingFeeformerrors = error;
            });
        }
      });
          },
          async  showfilingFeesPopup(editFilngFee = false) {
            // console.log(JSON.stringify(this.petitionDetails))
            if(this.checkProperty(this.petitionDetails, 'filingFeeDetails','dueDate')){
              this.dueDate = this.checkProperty(this.petitionDetails, 'filingFeeDetails','dueDate');
            }else{
              if(this.configDetails && this.checkProperty(this.configDetails, 'invoicePaymentTermsDays')){
                let addDays = this.checkProperty(this.configDetails, 'invoicePaymentTermsDays')
                let today = moment();
                let result = today.add(addDays, 'days').format("YYYY-MM-DD"); 
                this.dueDate = result;
              }else{
                let addDays = 30
                let today = moment();
                let result = today.add(addDays, 'days').format("YYYY-MM-DD"); 
                this.dueDate = result;
                // this.dueDate = moment().format("YYYY-MM-DD");
              }
            }
            
            if(this.checkProperty(this.petitionDetails, 'filingFeeDetails','invoiceDate')){
              this.invoiceDate = this.checkProperty(this.petitionDetails, 'filingFeeDetails','invoiceDate');
            }else{
              this.invoiceDate = moment().format("YYYY-MM-DD");
            }
    this.removedInvoiceItems =[];
    this.newlyAddInvoiceItems =[];
      await this.getListcat()
      this.editFilngFee = editFilngFee;
      this.DocErr=false;
      this.filingFeeData = [
        {
          amount: null,
          invoice: false,
          description: "",
        },
      ];
      if (
        this.editFilngFee &&
        this.checkProperty(this.petitionDetails ,'filingFeeDetails' ,'feeDetails') 
      ) {
        this.filingFeeData = [];
        this.filingFeeData = _.cloneDeep(this.petitionDetails.filingFeeDetails.feeDetails);
        //this.filingFeeDocs =[];
        if(false){
          if(this.checkProperty(this.petitionDetails ,'filingFeeCategoryType') =="pre_defined" && this.invoicecategoryList.length>0){
          let filingFeeData = _.cloneDeep(this.petitionDetails.filingFeeDetails.feeDetails);
          //descriptionId
          let finalItems =[];
          _.forEach(filingFeeData ,(dbInvoice)=>{
              let isExistsInML = _.find(this.invoicecategoryList ,{ "id": dbInvoice['descriptionId']});
              if(isExistsInML){
                finalItems.push(dbInvoice);
              }else{
                //removed Items
                this.removedInvoiceItems.push(dbInvoice);
              }

          })
          _.forEach(this.invoicecategoryList ,(invCat)=>{
              let isExistsInML = _.find(filingFeeData ,{ "descriptionId": invCat['id']});
              let isAlreadyExists  = _.find(finalItems ,{ "descriptionId": invCat['id']});

              if(!isExistsInML && !isAlreadyExists){

              let item = {  amount: null, description: "",  invoice: false,"descriptionId":''  };

              item['description'] = this.checkProperty(invCat ,"name");
              item['amount'] = this.checkProperty(invCat ,"amount");
              item['descriptionId'] = this.checkProperty(invCat ,"id");
              item['descriptionType'] = this.checkProperty(invCat,"type");
              item['newly_add'] = true;
              this.newlyAddInvoiceItems.push(item);
              finalItems.push(item);
              }

          })
          this.filingFeeData =finalItems;

          }else{
            this.filingFeeData = _.cloneDeep(this.petitionDetails.filingFeeDetails.feeDetails);
          }
        }
        if(this.checkProperty(this.petitionDetails['filingFeeDetails'] ,'filingFeeDocs', 'cheques') && this.checkProperty(this.petitionDetails['filingFeeDetails']['filingFeeDocs'], 'cheques', 'length')>0){
         
            this.filingFeeDocs = this.petitionDetails.filingFeeDetails.filingFeeDocs['cheques'];
            this.value = this.petitionDetails.filingFeeDetails.filingFeeDocs['cheques'];
            this.DocErr =false;
            // console.log(JSON.stringify(this.filingFeeDocs))
        }
     
      }else{

        if( this.invoicecategoryList.length>0){
          this.filingFeeData = [];
          this.filingFeeDocs =[];
          //this.DocErr=false
          _.forEach(this.invoicecategoryList ,(invCat)=>{
            let item = {  amount: null, description: "",  invoice: false,"descriptionId":''  };
            item['description'] = this.checkProperty(invCat ,"name");
            item['amount'] = this.checkProperty(invCat ,"amount");
            item['descriptionId'] = this.checkProperty(invCat ,"id");
            item['descriptionType'] = this.checkProperty(invCat,"type")
            
            this.filingFeeData.push(item);

          });
        }
      }
      
      this.filingFeesPopup = true;
      this.filingFeeformerrors = "";
      this.submitingFilingFee = false;
        this.filingFeeComment = this.checkProperty(
        this.petitionDetails,
        "filingFeeDetails",
        "comment"
      );
      if(!editFilngFee){
        this.filingFeeComment ='Thank you for the business. Please process this at the earliest possible.'
      }
      this.emailInvoice = true;
      this.$modal.show('FilingFeesPopup')
      
      setTimeout(()=>{
        this.$validator.reset();
      } ,10);

          },
    getListcat(){
      let self = this;
      let Payload={
       petitionId:this.checkProperty( this.petitionDetails ,'_id')
     }
      return new Promise((res ,rej)=>{
  
      self.$store.dispatch("getList",{data:Payload ,path:'/invoices/get-filing-fee-categories'} )
      .then((response) => {
        self.invoicecategoryList = response;
        res();      
              
      }).catch((err)=>{
        res();
      });
    });
  },
  createOrupdateInvoice(callFrom = "") {
    
    let self = this;
    this.validatefilingFeeDescrition = true;
    this.filingFeeformerrors = "";
    this.DocErr=false;
     if(this.checkProperty(this.petitionDetails,'filingFeeCategoryType')=='pre_defined' && this.checkProperty(this.filingFeeDocs,'length')<=0){
      this.DocErr=true;
     }
   
    this.$validator.validateAll("filingFeesform").then((result) => {
     // alert(result)
      let includeInvoicesList = _.filter(this.filingFeeData ,{"invoice":false});
      if( includeInvoicesList && includeInvoicesList.length<=0){
          this.filingFeeformerrors = "Include at least one item into invoice";
          return false;
        }
      if (result && this.DocErr==false) {
        var totala = 0;
        this.filingFeeData.forEach((i) => {
          totala = totala + parseInt(i.amount);
        });
        let filingFeeData = _.cloneDeep(this.filingFeeData);
        if (callFrom == "save-filing-fees") {
          //filingFeeData  = _.filter(filingFeeData , {'invoice':false});
        }
        let benName='';
        if(this.checkProperty(this.petitionDetails['filingFeeDetails'] ,'petitionDetails', 'beneficiaryInfo') && this.checkProperty(this.petitionDetails['filingFeeDetails']['petitionDetails'], 'beneficiaryInfo', 'name')){
          benName = this.checkProperty(this.petitionDetails['filingFeeDetails']['petitionDetails'], 'beneficiaryInfo', 'name')
        }
        var postdata = {
          companyName: '',
          beneficiaryName: benName, 
          beneficiaryCustomId: '',
          petitionType: this.checkProperty( this.petitionDetails , 'typeDetails','name'), 
          companyId: self.checkProperty(self.petitionDetails, "filingFeeDetails", "petitionerId"),
          petitionId: this.checkProperty( this.petitionDetails ,'_id'),
          feeDetails: filingFeeData,
          filingFeeDocs:{"cheques":[]},
          amount: totala?totala:0,
          today: moment().format("YYYY-MM-DD"),
          invoiceDate:this.invoiceDate,
          dueDate:this.dueDate,
          customer: {
            Id: self.checkProperty(self.petitionDetails, "companyDetails", "qbCustomerId"),
            displayName: "", //this.petitionDetails.companyDetails.name,
            email: "", //this.petitionDetails.companyDetails.authorizedSignatory.email,
          },
          invoiceTerms: {
            days: 30,
          },
          comment: this.filingFeeComment,
          emailInvoice: self.checkPaymentIntigration, //this.emailInvoice
        };
  
        if(this.filingFeeDocs.length>0){
          postdata['filingFeeDocs']['cheques'] = this.filingFeeDocs;
         
        }
  
        if (this.checkProperty(self.petitionDetails, "companyDetails")) {
          postdata["customer"]["Id"] = this.checkProperty(
            self.petitionDetails,
            "companyDetails",
            "qbCustomerId"
          );
          postdata["customer"]["displayName"] = this.checkProperty(
            self.petitionDetails,
            "authorizedSignatory",
            "name"
          );
          postdata["customer"]["email"] = this.checkProperty(
            self.petitionDetails,
            "authorizedSignatory",
            "email"
          );
        }
  
        let totalPaidAmount =0
          
          if(this.checkProperty(this.petitionDetails,'filingFeeDetails','partlyPaidLogs') && this.checkProperty(this.petitionDetails['filingFeeDetails'],'partlyPaidLogs','length')>0 ){
          let filingfeeList = _.cloneDeep(this.checkProperty(this.petitionDetails,'filingFeeDetails','partlyPaidLogs'))
            filingfeeList.forEach(item => { totalPaidAmount += parseInt(item.amount);  });
          }
          
        this.submitingFilingFee = true;
        if (
          this.checkProperty(self.petitionDetails, "invoiceId") &&
          this.petitionDetails.invoiceId != null
        ) {
          postdata.invoiceId = this.petitionDetails.invoiceId;
          postdata.statusId = 2;
          postdata.statusName = "Sent";
  
          
          let dueAmount = totala-totalPaidAmount
          
        if(dueAmount <=0){
          postdata.statusId = 6;
          postdata.statusName = "Fully Paid";
        }
  
  
          if(this.checkProperty(this.petitionDetails ,'filingFeeCategoryType') =="pre_defined" && this.invoicecategoryList.length>0){
             let dbFilingFeeData = _.cloneDeep(this.petitionDetails.filingFeeDetails.feeDetails);
             //this.removedInvoiceItems =[];
             //this.newlyAddInvoiceItems =[];
             if(this.removedInvoiceItems.length>0 || this.newlyAddInvoiceItems.length>0 ){
  
             let dbAmount =0
              dbFilingFeeData.forEach((i) => {
                dbAmount = totala + parseInt(i.amount);
               });
  
  
                 
                  if(totala >totalPaidAmount && totalPaidAmount>0){
                    postdata.statusId = 5;
                    postdata.statusName = "Partially Paid";
  
                  }else if(totala==totalPaidAmount){
                    postdata.statusId = 6;
                    postdata.statusName = "Fully Paid";
  
                  }else if(totalPaidAmount<totala && totalPaidAmount>0 ){
                    postdata.statusId = 5;
                    postdata.statusName = "Partially Paid";
  
                  }
                   if(dueAmount <=0){
                    postdata.statusId = 6;
                    postdata.statusName = "Fully Paid";
                  }
  
                }
          }
          this.$store
            .dispatch("updateFilingFees", postdata)
            .then((response) => {
              this.submitingFilingFee = false;
              this.filingFeesPopup = false;
              this.hideMe();
              this.editFilngFee = false;
              this.submitingFilingFee = false;
              
          
              this.showToster({ message: response.message, isError: false });
              // setTimeout(() => {
              //   this.reloadPetition("Fees/Invoices");
              // }, 100);
            })
            .catch((error) => {
              this.submitingFilingFee = false;
              if (callFrom == "save-filing-fees") {
                this.filingFeesPopup = false;
                //this.$modal.hide("FilingFeesModal");
                this.editFilngFee = false;
                
                this.submitingFilingFee = false;
                this.showToster({ message: error, isError: true });
                // setTimeout(() => {
                //   this.reloadPetition("Fees/Invoices");
                // }, 100);
                this.hideMe();
              } else {
                this.filingFeeformerrors = error;
               
              }
            });
        } else {
          this.$store
            .dispatch("submitFilingFees", postdata)
            .then((response) => {
              this.filingFeesPopup = false;
              //this.$modal.hide("FilingFeesModal");
              this.submitingFilingFee = false;
             
              this.showToster({ message: response.message, isError: false });
              // setTimeout(() => {
              //   this.reloadPetition("Fees/Invoices");
              // }, 100);
              this.hideMe();
            })
            .catch((error) => {
              if (callFrom == "save-filing-fees") {
                this.filingFeesPopup = false;
                this.$modal.hide("FilingFeesModal");
                this.submitingFilingFee = false;
                
                this.showToster({ message: error, isError: true });
                // setTimeout(() => {
                //   this.reloadPetition("Fees/Invoices");
                // }, 100);
                this.hideMe();
              } else {
                this.submitingFilingFee = false;
                this.filingFeeformerrors = error;
              }
            });
        }
      }
    });
  },
  getGlobalConfigDetails() {
      let postData = {};
      this.configDetails = null;
      this.$store
        .dispatch("commonAction", { data: postData, path: "global-config/details" })
        .then((response) => {
          if (this.checkProperty(response, "config")) {
            this.configDetails = response["config"];
            
          }
        });
    },

        },
        mounted(){
          this.getGlobalConfigDetails()           
          this.showfilingFeesPopup(true);

        },
        computed: {
          getUscisSection(){
            let returnVal = false;
            // filingFeeData descriptionType USCIS   
            if(this.filingFeeData && this.checkProperty(this.filingFeeData, 'length')>0){
              let findObj = _.find(this.filingFeeData, {'descriptionType':'USCIS', 'isSelected':true});
              if(findObj){
                returnVal = true;
              }
            }
            return returnVal; 
          },
          getInternalSection(){
            let returnVal = false;
            // filingFeeData descriptionType USCIS
            if(this.filingFeeData && this.checkProperty(this.filingFeeData, 'length')>0){
              let findObj = _.find(this.filingFeeData, {'descriptionType':'Internal', 'isSelected':true});
              if(findObj){
                returnVal = true;
              }
            }
            return returnVal;
          },
          getotherSection(){
            let returnVal = false;
            // filingFeeData descriptionType USCIS
            if(this.filingFeeData && this.checkProperty(this.filingFeeData, 'length')>0){
              let findObj = _.find(this.filingFeeData, {'descriptionType':'Other', 'isSelected':true});
              if(findObj){
                returnVal = true;
              }
            }
            return returnVal;
          },
        }

    }
</script>